<ng-container *transloco="let t">
  @if (isAvailable()) {
    <p-button
      class="whats-new-trigger"
      icon="pi pi-megaphone"
      iconPos="left"
      [ariaLabel]="t('whatsNew.title')"
      [label]="t('whatsNew.title')"
      [pt]="buttonPT"
      [text]="true"
      (onClick)="onOpenDialog()" />
  }
</ng-container>
